export default from './demo-message-root';



// WEBPACK FOOTER //
// ./app/containers/demo-message-root/index.js